export enum Chains {
  ETHEREUM = "Ethereum",
  BITCOIN = "Bitcoin",
  TETHER = "Tether",
  EUROTETHER = "Euro Tether",
  POLYGON = "Polygon",
  CRYPTOPAY = "Crypto Pay"
}
